<template>
  <div id="page-campaign-edit">
    <vs-alert
      color="danger"
      title="Campaign Not Found"
      :active.sync="campaignNotFound"
    >
      <span>
        Campaign record with id
        <strong>{{ $route.params.campaignId }}</strong> not found.
      </span>
      <span>
        <span>Check</span>
        <router-link
          :to="{ name: 'campaign-list' }"
          class="text-inherit underline"
          >All Campaigns</router-link
        >
      </span>
    </vs-alert>

    <vx-card v-if="localData">
      <dx-validation-group ref="validation-group">
        <div class="dx-fieldset">
          <!-- <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("Campaign.Agency") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="agencies"
                :search-enabled="true"
                :value.sync="idAgency"
                display-expr="name"
                value-expr="id"
              >
                <DxValidator>
                  <DxRequiredRule :message="$t('Advertiser.AgencyRequired')" />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("Advertiser.AdvertiserIdDetail") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="providerAdvertisers"
                :search-enabled="true"
                :value.sync="data.advertiserId"
                display-expr="name"
                value-expr="id"
                ><DxValidator>
                  <DxRequiredRule
                    :message="$t('Advertiser.ProviderAdvertiserRequired')"
                  />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div> -->
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("Campaign.Name") }}
            </div>
            <div class="dx-field-value">
              <DxTextBox :value.sync="localData.name">
                <DxValidator>
                  <DxRequiredRule :message="$t('Campaign.NameRequired')" />
                </DxValidator>
              </DxTextBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("Campaign.StartDate") }}
            </div>
            <div class="dx-field-value">
              <DxDateBox :value.sync="localData.startDate"> </DxDateBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("Campaign.EndDate") }}
            </div>
            <div class="dx-field-value">
              <DxDateBox :value.sync="localData.endDate"> </DxDateBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">
              {{ $t("Campaign.StrategyType") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="strategyTypes"
                :search-enabled="true"
                :value.sync="localData.idStrategyType"
                display-expr="description"
                value-expr="id"
              >
                <DxValidator>
                  <DxRequiredRule
                    :message="$t('Campaign.StrategyTypeRequired')"
                  />
                </DxValidator>
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field" v-if="localData.idStrategyType === 3">
            <div class="dx-field-label">
              {{ $t("Campaign.JobFeed") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="jobFeeds"
                :search-enabled="true"
                :value.sync="localData.externalStrategyListId"
                display-expr="name"
                value-expr="id"
              >
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field" v-if="localData.idStrategyType === 5">
            <div class="dx-field-label">
              {{ $t("Campaign.ArticleList") }}
            </div>
            <div class="dx-field-value">
              <DxSelectBox
                :items="articleLists"
                :search-enabled="true"
                :value.sync="localData.externalStrategyListId"
                display-expr="name"
                value-expr="id"
              >
              </DxSelectBox>
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label">{{ $t("Campaign.NewsFeeds") }}</div>
            <div class="dx-field-value">
              <DxTagBox
                :data-source="newsArticleLists"
                display-expr="name"
                value-expr="id"
                :search-enabled="true"
                :value.sync="localData.newsArticleListIds"
                :show-selection-controls="true"
                apply-value-mode="useButtons"
              />
            </div>
          </div>
          <div class="dx-field" v-if="$acl.check('admin')">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
              <DxCheckBox
                :value.sync="localData.isPremium"
                :text="$t('Campaign.IsPremium')"
              />
            </div>
          </div>
          <div class="dx-field">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
              <DxCheckBox
                :value.sync="localData.isActive"
                :text="$t('Campaign.IsActive')"
              />
            </div>
          </div>
          <div class="dx-field" v-if="$acl.check('admin')">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
              <DxCheckBox
                :value.sync="localData.hasStrategies"
                :text="$t('Campaign.HasStrategies')"
              />
            </div>
          </div>
          <div class="dx-field" v-if="$acl.check('admin')">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
              <DxCheckBox
                :value.sync="localData.hasSubscriptions"
                :text="$t('Campaign.HasSubscriptions')"
              />
            </div>
          </div>
          <div class="dx-field" v-if="$acl.check('admin')">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
              <DxCheckBox
                :value.sync="localData.advertiserCanAddSubscription"
                :text="$t('Campaign.AdvertiserCanAddSubscription')"
              />
            </div>
          </div>
          <div class="dx-field" v-if="$acl.check('admin')">
            <div class="dx-field-label"></div>
            <div class="dx-field-value">
              <DxCheckBox
                :value.sync="localData.retailerCanBuySubscription"
                :text="$t('Campaign.RetailerCanBuySubscription')"
              />
            </div>
          </div>
        </div>
      </dx-validation-group>
    </vx-card>
    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" @click="saveChanges">{{
            $t("Save")
          }}</vs-button>
          <vs-button
            class="ml-4 mt-2"
            type="border"
            color="warning"
            @click="cancel"
            >{{ $t("Cancel") }}</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>

// Store Module
import moduleCampaignManagement from '@/store/campaign-management/moduleCampaignManagement.js'
import moduleJobFeedManagement from '@/store/job-feed-management/moduleJobFeedManagement.js'
import moduleArticleListManagement from '@/store/article-list-management/moduleArticleListManagement.js'
import moduleNewsArticleListManagement from '@/store/news-article-list-management/moduleNewsArticleListManagement.js'
import { DxSelectBox } from 'devextreme-vue/select-box'
import { DxTextBox } from 'devextreme-vue/text-box'
import { DxCheckBox } from 'devextreme-vue/check-box'
import { DxDateBox } from 'devextreme-vue/date-box'
import DxValidationGroup from 'devextreme-vue/validation-group'
import DxTagBox from 'devextreme-vue/tag-box';
import {
  DxValidator,
  DxRequiredRule
} from 'devextreme-vue/validator'

import { notifyMixin } from '@/mixins/notifyMixin'

export default {
  mixins: [notifyMixin],
  data () {
    return {
      localData: {},
      campaignNotFound: false,
      jobFeeds: [],
      articleLists: [],
      newsArticleLists: []
    }
  },
  components: {
    DxSelectBox,
    DxTextBox,
    DxCheckBox,
    DxValidator,
    DxValidationGroup,
    DxRequiredRule,
    DxDateBox,
    DxTagBox
  },
  computed: {
    strategyTypes () {
      return this.$store.state.refCodes.strategyTypes.map(a => {
        return { ...a, description: this.$t(`StrategyTypeList.${a.description}`) }
      })
    },
  },
  watch: {
    localData: {
      deep: true,
      handler (val) {
        val.hasStrategies = this.localData.idStrategyType > 1 && this.localData.idStrategyType != 5
      }
    }
  },
  methods: {
    fetchData (campaignId) {
      this.$store.dispatch('campaignManagement/fetchCampaign', campaignId)
        .then(res => {
          this.localData = res.data.campaign
          if (this.localData === null) {
            this.campaignNotFound = true
            return
          }
          Promise.all([
            this.fetchJobFeeds(this.localData.idOrganisation),
            this.fetchArticleLists(this.localData.idOrganisation),
            this.fetchNewsArticleLists(this.localData.idOrganisation)
          ])
        })
        .catch(err => {
          if (err.response && err.response.status === 404) {
            this.campaignNotFound = true
            return
          }
          this.notifyError(err)
        })
    },
    fetchJobFeeds (idOrganisation) {
      this.$store.dispatch('jobFeedManagement/fetchJobFeeds', idOrganisation)
        .then(res => {
          this.jobFeeds = res.data.items
        })
    },
    fetchArticleLists (idOrganisation) {
      this.$store.dispatch('articleListManagement/fetchArticleLists', idOrganisation)
        .then(res => {
          this.articleLists = res.data.items
        })
    },
    fetchNewsArticleLists (idOrganisation) {
      this.$store.dispatch('newsArticleListManagement/fetchNewsArticleLists', idOrganisation)
        .then(res => {
          this.newsArticleLists = res.data.items
        })
    },
    saveChanges () {
      const validationGroup = this.$refs["validation-group"].instance
      const result = validationGroup.validate()
      if (!result.isValid) {
        return
      }
      this.$store.dispatch('campaignManagement/saveCampaign', this.localData)
        .then(() => {
          this.$router.push("/campaign/list")
          this.notifySuccess(this.$t("Campaign.Updated"))
        })
        .catch(err => { console.error(err) })
    },
    cancel () {
      this.$router.push("/campaign/list")
    }
  },
  created () {
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule('campaignManagement', moduleCampaignManagement)
      moduleCampaignManagement.isRegistered = true
    }
    if (!moduleJobFeedManagement.isRegistered) {
      this.$store.registerModule('jobFeedManagement', moduleJobFeedManagement)
      moduleJobFeedManagement.isRegistered = true
    }
    if (!moduleArticleListManagement.isRegistered) {
      this.$store.registerModule('articleListManagement', moduleArticleListManagement)
      moduleArticleListManagement.isRegistered = true
    }
    if (!moduleNewsArticleListManagement.isRegistered) {
      this.$store.registerModule('newsArticleListManagement', moduleNewsArticleListManagement)
      moduleNewsArticleListManagement.isRegistered = true
    }

    this.fetchData(this.$route.params.campaignId)
  }
}

</script>

